"use client";

import { useSidebar } from "@workspace/frontend-ui";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

const MobileNavHandler = () => {
  const pathname = usePathname();
  const { toggleSidebar, openMobile } = useSidebar();

  useEffect(() => {
    if (openMobile) {
      toggleSidebar();
    }
  }, [pathname]);

  return null;
};

export default MobileNavHandler;
